var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMtSatisfeitoCinza = function SvgMtSatisfeitoCinza(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 23,
    height: 23,
    x: 1.5,
    y: 2,
    rx: 11.5
  }), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "113%",
    height: "113%",
    x: "-6.5%",
    y: "-6.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -3,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 0.82745098 0 0 0 0 0.831372549 0 0 0 0 0.866666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#696979",
    fillRule: "nonzero",
    d: "M13 0c7.18 0 13 5.82 13 13s-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0zm0 1.53C6.665 1.53 1.53 6.664 1.53 13c0 6.335 5.135 11.47 11.47 11.47 6.335 0 11.47-5.135 11.47-11.47 0-6.335-5.135-11.47-11.47-11.47z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.5)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0F0F5",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#696979",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.024 14.91a.725.725 0 0 1 .701-.91h10.953c.48 0 .829.46.697.923-.79 2.778-3.265 4.626-6.265 4.626-2.987 0-5.344-1.835-6.086-4.639zm1.836.742c.813 1.521 2.35 2.447 4.25 2.447 2 0 3.673-1.024 4.507-2.649H8.758l.102.202zM18.106 10.099a.783.783 0 0 0 1.067.097.701.701 0 0 0 .103-1.019l-1.668-1.929a.781.781 0 0 0-1.17 0l-1.668 1.93a.701.701 0 0 0 .103 1.018c.323.254.8.21 1.067-.097l1.083-1.254 1.083 1.254zM9.305 8.845L8.222 10.1a.783.783 0 0 1-1.067.097.701.701 0 0 1-.103-1.019L8.72 7.248a.781.781 0 0 1 1.17 0l1.668 1.93a.701.701 0 0 1-.103 1.018.783.783 0 0 1-1.067-.097L9.305 8.845z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMtSatisfeitoCinza, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mt-satisfeito-cinza.687b5d01.svg";
export { ForwardRef as ReactComponent };